<template>
  <div class="unit-tag">
    <div class="unit-tag__name">
      <p class="u-text-gray">
        {{ unit.name }}
      </p>
      <div class="unit-tag__breadcrumb">
        <unit-breadcrumb :unit="unit" />
      </div>
    </div>
    <button
      v-if="removable"
      class="unit-tag__remove-btn"
      :aria-label="$t('actions.remove')"
      @click="$emit('remove')"
    />
  </div>
</template>

<script>
import UnitBreadcrumb from '#src/components/units/UnitBreadcrumb.vue'

export default {
  components: {
    UnitBreadcrumb
  },
  props: {
    unit: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      default: true
    }
  },
  emits: ['remove']
}
</script>
<style lang="scss">
@use "#src/assets/scss/variables" as *;

.unit-tag {
  margin-right: auto;
  background: $light-blue;
  display: inline-flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  border-radius: 1.5rem;
  position: relative;
  padding: 0.75rem;
  width: 100%;
}
.unit-tag__name {
  width: 100%;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  p {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
.unit-tag__remove-btn {
  position: absolute;
  top: -0.25rem;
  right: -0.25rem;
  width: 1.25rem;
  height: 1.25rem;
  overflow: hidden;
  background-color: white;
  border-radius: 100%;
  text-indent: 100%;
  border: 1px solid $light-blue;
  visibility: hidden;
  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml,%3Csvg width='7' height='7' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.7071.2929L3.121 1.706 4.53553.2929c.39053-.39053 1.0237-.39053 1.41422 0 .39052.39052.39052 1.02368 0 1.4142L4.535 3.121l1.41475 1.41453c.39052.39053.39052 1.0237 0 1.41422-.39053.39052-1.0237.39052-1.41422 0L3.121 4.535 1.7071 5.94975c-.39052.39052-1.02368.39052-1.4142 0-.39053-.39053-.39053-1.0237 0-1.41422L1.706 3.121.2929 1.7071c-.39053-.39052-.39053-1.02368 0-1.4142.39052-.39053 1.02368-.39053 1.4142 0z' fill='%238F95A1' fill-rule='evenodd'/%3E%3C/svg%3E");
    background-size: 0.5rem 0.5rem;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-color: white;
  }
}
.unit-tag:hover .unit-tag__remove-btn {
  visibility: visible;
}

.unit-tag__breadcrumb span {
  padding: 0.0625rem 0.375rem;
  color: #fff;
  background: $blue-600;
  font-size: 0.6875rem;
  font-weight: 700;
  border-radius: 0.25rem;
  vertical-align: middle;
  white-space: nowrap;
}

.affiliation-picker--adv-with-author {
  .unit-tag--adv-search {
    background: $light-gray-300;
  }
}
</style>
